// :cow: Cosmose CONFIDENTIAL :iso:
export enum FloorName {
  UNKNOWN_FLOOR = 'Unknown floor'
}
